import {
  FilterCategory,
  type FilterCategoryType,
} from "@/store/news/feed.types";
import type { Category } from "@/types/shared";

/**
 * Mapping from FilterCategory to Category enum values for Share of Voice filters.
 * This maintains consistency with the established filter system while allowing
 * specific categorization for Share of Voice analysis.
 */
export const FILTER_CATEGORY_TO_CATEGORY_MAP: Partial<
  Record<FilterCategoryType, Category[]>
> = {
  [FilterCategory.PUBLICATION_TIER]: ["TIER_1", "TIER_2", "TIER_3"],
  [FilterCategory.PROMINENCE]: [
    "HEADLINE",
    "FEATURE",
    "LEDE",
    "PASSING_MENTION",
    "UNKNOWN",
  ],
  [FilterCategory.SENTIMENT]: ["POSITIVE", "NEUTRAL", "NEGATIVE"],
};

/**
 * Order of filter categories for Share of Voice display
 */
export const SHARE_OF_VOICE_FILTER_ORDER = [
  FilterCategory.PUBLICATION_TIER,
  FilterCategory.PROMINENCE,
  FilterCategory.SENTIMENT,
];

/**
 * Get the category display order based on filter category mapping
 */
export const getCategoryDisplayOrder = (): Category[] => {
  const order: Category[] = [];

  for (const filterCategory of SHARE_OF_VOICE_FILTER_ORDER) {
    const categories = FILTER_CATEGORY_TO_CATEGORY_MAP[filterCategory] || [];
    order.push(...categories);
  }

  return order;
};
